import { render, staticRenderFns } from "./AddNewSkillQualificationPopUp.vue?vue&type=template&id=497f7ffe&scoped=true&"
import script from "./AddNewSkillQualificationPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewSkillQualificationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSkillQualificationPopUp.vue?vue&type=style&index=0&id=497f7ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f7ffe",
  null
  
)

export default component.exports